<template>
    <div class="backend-container deal-share analytics-container">
        <BackendHeader />
        <br />
        <br />
        <button @click="refreshIframe()">REFRESH</button>
        <iframe src="/ClickyAnalytics" ref="iframe"></iframe>

    </div>
</template>

<script>

    import api from '@/api'
    import settings from '@/settings'
    import BackendHeader from '@/components/BackendHeader'

    export default {
        name: "home",
        data() {
            return {
                
            };
        },
        methods: {
            refreshIframe() {
                this.$refs.iframe.contentWindow.location.reload();
            }
        },
        mounted() {
            
        },
        components: {
            BackendHeader
        }
    };
</script>
<style>
    iframe {
        width: 250px;
        height: 300px;
        border: 0;
    }

    .analytics-container{
        width: 600px;
        margin-left: auto;
        margin-right: auto;
    }

</style>